import { useState, useCallback } from "react";

const EMPTY_FILTERS = { search: "", status: "", aging: "", dateFrom: "", dateTo: "" };
const PARAM_KEYS = { search: "search", status: "status", aging: "aging", dateFrom: "date_from", dateTo: "date_to" };

export function useOrderFilters(createdBy, clearCreatedBy) {
  const [filters, setFilters] = useState(EMPTY_FILTERS);

  const params = useCallback(() => {
    const p = {};
    Object.entries(PARAM_KEYS).forEach(([key, param]) => {
      if (filters[key]) p[param] = filters[key];
    });
    if (createdBy) p.created_by = createdBy;
    return p;
  }, [filters, createdBy]);

  const reset = useCallback(() => {
    setFilters(EMPTY_FILTERS);
    if (createdBy) clearCreatedBy();
  }, [createdBy, clearCreatedBy]);

  const isEmpty = Object.values(filters).every((v) => !v) && !createdBy;
  const setter = (key) => (v) => setFilters((prev) => ({ ...prev, [key]: v }));

  return {
    search: filters.search, setSearch: setter("search"),
    status: filters.status, setStatus: setter("status"),
    aging: filters.aging, setAging: setter("aging"),
    dateFrom: filters.dateFrom, setDateFrom: setter("dateFrom"),
    dateTo: filters.dateTo, setDateTo: setter("dateTo"),
    params, reset, isEmpty,
  };
}
